module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_vestland_neg.335ace74.png";